var path = 'apps_manager/app.html';
var html = "<div ng-controller=\"AppsCtrl\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;